<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="msgSemResultado">
    Não foram encontradas pessoas jurídicas com os filtros informados.
  </div>
  <div class="row" *ngIf="pessoasJuridicas && pessoasJuridicas.length">
    <div class="d-flex justify-content-end">
      <button [disabled]="pessoasJuridicas.length == 0" class="btn btn-secondary m-0" type="button"
        (click)="btnExportarPessoasJuridicas()" placement="top" ngbTooltip="Exporta as pessoas jurídicas listadas">
        <i class="fa fa-file"></i> Exportar pessoas jurídicas</button>
    </div>
    <div *ngIf="dataHoraResultado" class="float-start letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
    <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
      [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
      <div class="table-responsive">
        <table class="table table-hover cursor-pointer">
          <thead>
            <tr class="text-nowrap">
              <th id="col-agente" scope="col">
                <bn-ordenacao
                  [ordenacao]="atributosOrdenacao"
                  [atributo]="'nome'"
                  [nomeAtributoExibicao]="'Nome'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th id="col-data-inicio" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'sigla'" [nomeAtributoExibicao]="'Sigla'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th id="col-data-fim" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpj'" [nomeAtributoExibicao]="'CNPJ'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let pessoaJuridica of pessoasJuridicas">
              <td>{{ pessoaJuridica.nome }}</td>
              <td>{{ pessoaJuridica.sigla }}</td>
              <td>{{ pessoaJuridica.cnpj | bnCnpj }}</td>
            </tr>
          </tbody>

        </table>
      </div>
    </bn-paginacao>
  </div>
</div>
